var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{ref:"input",staticClass:"hidden",attrs:{"src":_vm.input},on:{"load":_vm.onLoadInput}}),_c('canvas',{ref:"canvas",staticClass:"hidden",attrs:{"width":_vm.inputWidth,"height":_vm.inputHeight}})])}
var staticRenderFns = []

export { render, staticRenderFns }